const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const S3QueryUrl = {
    List: `${Backofficebff}/v1/s3/list`,
    File: `${Backofficebff}/v1/s3/file`,
    ImageBase64: `${Backofficebff}/v1/s3/image-base64`,
    PresignedDownload: `${Backofficebff}/v1/s3/files/presigned-download`,
};
